export const FETCH_SCRIPT_STEPS = 'FETCH_SCRIPT_STEPS';
export const FETCH_SCRIPT_STEPS_START = `${FETCH_SCRIPT_STEPS}_START`;
export const FETCH_SCRIPT_STEPS_SUCCESS = `${FETCH_SCRIPT_STEPS}_SUCCESS`;
export const FETCH_SCRIPT_STEPS_FAIL = `${FETCH_SCRIPT_STEPS}_FAIL`;

const SCRIPT_STEP_ENDPOINT_EMBED = [
  'usage',
  ...(window.ebfd ? ['ebPhaseTemplates'] : []),
].join(',');

export const fetchScriptSteps = planId => ({
  type: FETCH_SCRIPT_STEPS,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/script-steps`,
    method: 'getall',
    params: {
      plan: planId,
      embed: SCRIPT_STEP_ENDPOINT_EMBED,
      limit: 1000,
    },
  },
});

export const FETCH_SCRIPT_STEP = 'FETCH_SCRIPT_STEP';
export const FETCH_SCRIPT_STEP_START = `${FETCH_SCRIPT_STEP}_START`;
export const FETCH_SCRIPT_STEP_SUCCESS = `${FETCH_SCRIPT_STEP}_SUCCESS`;
export const FETCH_SCRIPT_STEP_FAIL = `${FETCH_SCRIPT_STEP}_FAIL`;

export const fetchScriptStep = stepId => ({
  type: FETCH_SCRIPT_STEP,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/script-steps/${stepId}`,
    method: 'get',
    params: {
      embed: SCRIPT_STEP_ENDPOINT_EMBED,
    },
  },
});

export const FETCH_SCRIPT_STEP_PERMISSIONS = 'FETCH_SCRIPT_STEP_PERMISSIONS';
export const FETCH_SCRIPT_STEP_PERMISSIONS_SUCCESS = `${FETCH_SCRIPT_STEP_PERMISSIONS}_SUCCESS`;
export const fetchScriptStepPermissions = stepId => ({
  type: FETCH_SCRIPT_STEP_PERMISSIONS,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/script-steps/${stepId}/permissions`,
    method: 'getall',
  },
  payload: { stepId },
});

export const SAVE_SCRIPT_STEP_PERMISSIONS = 'SAVE_SCRIPT_STEP_PERMISSIONS';
export const SAVE_SCRIPT_STEP_PERMISSIONS_SUCCESS = `${SAVE_SCRIPT_STEP_PERMISSIONS}_SUCCESS`;
export const saveScriptStepPermissions = payload => ({
  type: SAVE_SCRIPT_STEP_PERMISSIONS,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/script-steps`,
    method: 'post',
    params: payload,
  },
});
